export const darviewType = {
  GET_DAREVIEW_ORDERS: "GET_DAREVIEW_ORDERS",
  REQUEST_DARVIEW: "REQUEST_DARVIEW",
  REQUEST_DARVIEW_DONE: "REQUEST_DARVIEW_DONE",
};
